import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

interface SimpleHeaderProps {
  title: string;
  rightButton?: {
    icon: string;
    onClick: () => void;
    ariaLabel?: string;
  };
}

const SimpleHeader: React.FC<SimpleHeaderProps> = ({ title, rightButton }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <header className="header simple-header">
      <div className="header__left">
        <button
          className="header__back-button"
          onClick={handleBack}
          aria-label="Go back"
        >
          <img
            src="/images/arrow-left.png"
            alt="Back"
            width="24"
            height="24"
          />
        </button>
      </div>
      <div className="header__center">
        <h1 className="simple-header__title">{title}</h1>
      </div>
      <div className="header__right">
        {rightButton ? (
          <button
            className="header__right-button"
            onClick={rightButton.onClick}
            aria-label={rightButton.ariaLabel || 'Action button'}
          >
            <img
              src={rightButton.icon}
              alt={rightButton.ariaLabel || 'Action'}
              width="24"
              height="24"
            />
          </button>
        ) : (
          /* Empty space for layout balance */
          <div style={{ width: '40px', height: '40px' }} />
        )}
      </div>
    </header>
  );
};

export default SimpleHeader; 